import React, { FC } from 'react'

import { Icons, TrustIconProps } from '@Components/TrustIcons/common'

export const TrustIconsNL: FC<TrustIconProps> = ({ variant }: TrustIconProps) => (
  <Icons variant={variant}>
    <div>
      <img alt="" src="https://eu-images.contentstack.com/v3/assets/blt7dcd2cfbc90d45de/blt9d54b5b5ebd48765/ecommerce-eu-logo.png" />
    </div>
  </Icons>
)
